import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner, Badge } from 'reactstrap';
import { Block, BlockHead, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from '../../Component';
import AuthTenantNoData from '../../../pages/error/AuthTenantNoData';
import TextInput from '../../../pages/components/inputs/TextInput';
import axios from 'axios';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { TENANT_BEGIN_PROMOTION_DRAW_API, TENANT_RETRIEVE_CONTINUE_PROMOTION_DRAW_DATA_API, TENANT_SELECT_DRAW_WINNER_DATA_API } from '../../../api/api_data';
import { fail_retrieve_draw_participants, loading_retrieve_draw_participants, reset_retrieve_draw_participants, success_retrieve_draw_participants } from '../../../reducers/auth_tenant/retrieve_draw_participants_Slice';
import { RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_ERROR_MSG, RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_SUCCESS_MSG, RETRIEVE_TENANT_DASHBOARD_DATA_ERROR_MSG, RETRIEVE_TENANT_DASHBOARD_DATA_SUCCESS_MSG, TENANT_SELECT_DRAW_WINNER_ERROR_MSG, TENANT_SELECT_DRAW_WINNER_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { isEmpty, messageToast } from '../../../utils/Utils';
import AuthTenantLoader from '../../../pages/loaders/AuthTenantLoader';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../utils/app_consts";
import AuthTenantPageError from '../../../pages/error/AuthTenantPageError';
import { fail_retrieve_continue_promotion_draw_data, loading_retrieve_continue_promotion_draw_data, reset_retrieve_continue_promotion_draw_data, success_retrieve_continue_promotion_draw_data } from '../../../reducers/auth_tenant/retrieve_continue_promotion_draw_data_Slice';
import { motion, AnimatePresence } from 'framer-motion';
import { fail_tenent_select_draw_winner, loading_tenent_select_draw_winner, reset_tenent_select_draw_winner, success_tenent_select_draw_winner } from '../../../reducers/auth_tenant/tenent_select_draw_winner_Slice';
import Confetti from 'react-confetti';

const initialState = { draw_id: "", prizes: "" };

// Mock participants data for simulation
const normalizeParticipants = (apiParticipants) => {
  return apiParticipants?.map((item) => ({
    id: item.promotion_participant.id,
    code: item.promotion_participant.entry_code,
    name: `${item.participant.first_name} ${item.participant.last_name}`,
    email: item.participant.email_address,
  }));
};

const InitiatePromotionDrawModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {
  const [page_data, setPageData] = useState(data);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [form_data, setFormData] = useState(initialState);
  const [current_state, setCurrentState] = useState("pending");;
  const [participants, setParticipants] = useState([]);
  const [currentShufflingCodes, setCurrentShufflingCodes] = useState([]);
  const [currentPrizeIndex, setCurrentPrizeIndex] = useState(0);
  const [isPrizeComplete, setIsPrizeComplete] = useState(false);
  const [draw_state_loading, setDrawStateLoading] = useState(false);
  const [draw_state_error, setDrawStateError] = useState("");
  const [codes, setCodes] = useState([]);
  const [draw_winner_loading, setDrawWinnerLoading] = useState(false);
  const [draw_winner_error, setDrawWinnerError] = useState("");
  const [current_draw_winner, setCurrentDrawWinner] = useState("");
  const [draw_winners, setDrawWinners] = useState([]);
  const [draw_rank_prize, setDrawRankPrize] = useState([]);
  const hasFetchedRef = useRef(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [finalCodes, setFinalCodes] = useState([]);
  const [drawComplete, setDrawcomplete] = useState(false);


  // Add this to your component
  const [shufflingIndex, setShufflingIndex] = useState(0);
  const [shufflingInterval, setShufflingInterval] = useState(null);

  // Add this effect to handle shuffling animation
  useEffect(() => {
    if (!isPrizeComplete && codes.length > 0)
    {
      // Start shuffling animation
      const interval = setInterval(() => {
        setShufflingIndex(prev => (prev + 1) % codes.length);
      }, 600); // Change highlight every 100ms

      setShufflingInterval(interval);

      // Stop shuffling after 2 seconds and show winner
      const timeout = setTimeout(() => {
        clearInterval(interval);
        setShufflingInterval(null);
      }, 5000);

      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };

    }
  }, [codes, isPrizeComplete]);


  const [participants_loading, setParticipantsLoading] = useState(false);
  const [participants_error, setParticipantsError] = useState("");

  const shuffleIntervalRef = useRef(null);
  const prizeIntervalRef = useRef(null);

  const close_modal = () => {
    {
      // 🔥 FULL RESET on modal close
      stopShuffling();

      setParticipants([]);
      setCodes([]);
      setCurrentShufflingCodes([]);
      setDrawWinners([]);
      setCurrentDrawWinner(null);
      setDrawRankPrize([]);
      setIsPrizeComplete(false);
      setShufflingIndex(0);
      setDrawcomplete(false);

      setParticipantsError("");
      setDrawWinnerError("");
      setDrawStateError("");

      setParticipantsLoading(false);
      setDrawStateLoading(false);
      setDrawWinnerLoading(false);
      hasFetchedRef.current = false;
      closeModal();
    }
  };

  useEffect(() => {
    if (!isOpen)
    {
      // 🔥 FULL RESET on modal close
      setParticipants([]);
      setCodes([]);
      setCurrentShufflingCodes([]);
      setDrawWinners([]);
      setCurrentDrawWinner(null);
      setDrawRankPrize([]);
      setIsPrizeComplete(false);
      setShufflingIndex(0);
      setDrawcomplete(false);

      setParticipantsError("");
      setDrawWinnerError("");
      setDrawStateError("");

      setParticipantsLoading(false);
      setDrawStateLoading(false);
      setDrawWinnerLoading(false);
      hasFetchedRef.current = false;
      return;
    }


    if (data)
    {
      setCurrentState(data?.draw?.status); // make sure current_state is string!
      setCurrentState(data?.draw?.status);

      const mapped_prizes = [];
      for (let i = 0; i < data?.draw?.rules?.max_winners; i++)
      {
        mapped_prizes.push({
          id: `prize_${i + 1}`,
          prize: "",
          winnerSelected: false
        });
      }

      setFormData(prev => ({
        ...prev,
        draw_id: data?.draw?.id,
        prizes: mapped_prizes
      }));

      setPageData({
        ...data,
        draw_id: data?.draw?.id,
        prizes: mapped_prizes
      });

      const isInDraw = data?.draw?.status === "in_draw";

      if (isInDraw && !hasFetchedRef.current)
      {
        hasFetchedRef.current = true;
        retrieve_continue_promotion_draw_data_api(data?.draw?.id);
      }
    }

    return () => stopAllProcesses();

  }, [isOpen, data]);

  useEffect(() => {
    return () => {
      stopShuffling();
    };
  }, []);

  const retrieve_continue_promotion_draw_data_api = (draw_id) => {
    setCurrentState("in_draw");
    setDrawStateError("");
    setDrawStateLoading(true);

    dispatch(tenant_auth_actions_helper(
      loading_retrieve_continue_promotion_draw_data,
      success_retrieve_continue_promotion_draw_data,
      fail_retrieve_continue_promotion_draw_data,
      RETRIEVE_TENANT_DASHBOARD_DATA_ERROR_MSG,
      RETRIEVE_TENANT_DASHBOARD_DATA_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_CONTINUE_PROMOTION_DRAW_DATA_API}/${draw_id}`
    ));
  };

  // Listener
  const retrieve_continue_promotion_draw_data_listener = useSelector((state) => state.retrieve_continue_promotion_draw_data.retrieve_continue_promotion_draw_data);

  useEffect(() => {
    if (retrieve_continue_promotion_draw_data_listener.status !== app_consts.IDLE)
    {
      if (retrieve_continue_promotion_draw_data_listener.status === app_consts.LOADING)
      {
        setDrawStateLoading(true);
        setDrawStateError("");
      } else
      {
        if (retrieve_continue_promotion_draw_data_listener.status === app_consts.FAIL)
        {
          setDrawStateLoading(false);
          setDrawStateError(retrieve_continue_promotion_draw_data_listener.message);
          messageToast(retrieve_continue_promotion_draw_data_listener.message, app_consts.FAIL);
        } else if (retrieve_continue_promotion_draw_data_listener.status === app_consts.SUCCESS)
        {
          // Only Set if Paticipants Exists
          if (retrieve_continue_promotion_draw_data_listener.data?.draw_prizes?.length > 0)
          {
            setDrawRankPrize(retrieve_continue_promotion_draw_data_listener.data?.draw_prizes[0]);

            stopShuffling();

            const participants = retrieve_continue_promotion_draw_data_listener.data?.participants;

            const remapped_entry_codes = participants?.map(
              (dat) => dat?.promotion_participant?.entry_code
            );

            setCodes(remapped_entry_codes);
          }

          const responseData = retrieve_continue_promotion_draw_data_listener.data;

          setDrawWinners(retrieve_continue_promotion_draw_data_listener.data?.winners);
          // ✅ Normalize participants
          const normalized = normalizeParticipants(responseData.participants);

          setParticipants(normalized);

          // ✅ Map prizes from API (IMPORTANT)
          const mapped_prizes = responseData?.draw_prizes.map((prize, index) => ({
            id: prize.id,
            prize: prize.prize,
            rank: prize.rank,
            winnerSelected: false
          }));

          setFormData((prev) => ({
            ...prev,
            draw_id: responseData.draw.id,
            prizes: mapped_prizes
          }));

          setPageData((prev) => ({
            ...prev,
            draw: responseData.draw,
            prizes: mapped_prizes
          }));

          setDrawStateLoading(false);

          successFunction();

        }
        dispatch(reset_retrieve_continue_promotion_draw_data());
      }
    }
  }, [retrieve_continue_promotion_draw_data_listener]);

  const stopAllProcesses = () => {
    if (shuffleIntervalRef.current)
    {
      clearTimeout(shuffleIntervalRef.current);
      shuffleIntervalRef.current = null;
    }
    if (prizeIntervalRef.current)
    {
      clearInterval(prizeIntervalRef.current);
      prizeIntervalRef.current = null;
    }
  };

  const prize_check = () => {
    return form_data?.prizes?.every((item) => item?.prize?.trim());
  };

  const getRandomParticipants = (count) => {
    const shuffled = [...participants].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, Math.min(count, shuffled.length));
  };

  const startShuffling = (entry_codes) => {

    setTimeout(() => {
      let currentSpeed = 50;

      const generateShuffling = () => {
        return entry_codes
          ? [...entry_codes]
            .sort(() => 0.5 - Math.random())
            .slice(0, 12)
          : getRandomParticipants(12).map(p => p.code); // assuming getRandomParticipants returns objects with code property
      };

      const runShuffle = () => {
        shuffleIntervalRef.current = setTimeout(() => {
          setCurrentShufflingCodes(generateShuffling());
          runShuffle();
        }, currentSpeed);
      };

      runShuffle();
    }, 800); // 👈 small delay (feels natural)
  };

  const stopShuffling = () => {
    if (shuffleIntervalRef.current)
    {
      clearTimeout(shuffleIntervalRef.current);
      shuffleIntervalRef.current = null;
    }
  };

  const selectWinnerForPrize = () => {

    startShuffling(codes);

    // Send Dispatch
    dispatch(tenant_auth_actions_helper(
      loading_tenent_select_draw_winner,
      success_tenent_select_draw_winner,
      fail_tenent_select_draw_winner,
      TENANT_SELECT_DRAW_WINNER_ERROR_MSG,
      TENANT_SELECT_DRAW_WINNER_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${TENANT_SELECT_DRAW_WINNER_DATA_API}/${page_data?.draw?.id}`
    ));
  };

  // Listener
  const tenent_select_draw_winner_listener = useSelector((state) => state.tenent_select_draw_winner.tenent_select_draw_winner);

  useEffect(() => {
    if (tenent_select_draw_winner_listener.status !== app_consts.IDLE)
    {
      if (tenent_select_draw_winner_listener.status === app_consts.LOADING)
      {
        setDrawWinnerLoading(true);
        setDrawWinnerError("");

      } else
      {
        if (tenent_select_draw_winner_listener.status === app_consts.FAIL)
        {
          setDrawWinnerLoading(false);
          setDrawWinnerError(tenent_select_draw_winner_listener.message);
          messageToast(tenent_select_draw_winner_listener.message, app_consts.FAIL);
          stopShuffling();
        } else if (tenent_select_draw_winner_listener.status === app_consts.SUCCESS)
        {
          // Only Set if Paticipants Exists
          if (tenent_select_draw_winner_listener.data?.draw_prizes?.length > 0)
          {
            setDrawRankPrize(tenent_select_draw_winner_listener.data?.draw_prizes[0]);
          }

          const responseData = tenent_select_draw_winner_listener.data;

          // ✅ Normalize participants
          const normalized = normalizeParticipants(responseData.participants);

          setParticipants(normalized);

          // ✅ Map prizes from API (IMPORTANT)
          const mapped_prizes = responseData?.draw_prizes.map((prize, index) => ({
            id: prize.id,
            prize: prize.prize,
            rank: prize.rank,
            winnerSelected: false
          }));

          setFormData((prev) => ({
            ...prev,
            draw_id: responseData.draw.id,
            prizes: mapped_prizes,
            winners: responseData.winners
          }));

          setPageData((prev) => ({
            ...prev,
            draw: responseData.draw,
            prizes: mapped_prizes,
            winners: responseData.winners
          }));

          const participants = tenent_select_draw_winner_listener.data?.participants;

          const remapped_entry_codes = participants?.map(
            (dat) => dat?.promotion_participant?.entry_code
          );

          setCodes(remapped_entry_codes);

          // Stop after 2 seconds
          setTimeout(() => {
            stopShuffling();
            setDrawWinnerLoading(false);
            setIsPrizeComplete(true);
            setCurrentDrawWinner(responseData?.current_winner);
            setDrawWinners(responseData.winners);
            setShowConfetti(true);

          }, 2000);

          // Change Status after 5 seconds
          setTimeout(() => {
            setCurrentState(responseData?.draw?.status);
            if (responseData?.draw?.status === app_consts.COMPLETED_LOWER)
            {
              setShowConfetti(true);
              setDrawcomplete(true);
            }
          }, 3500);



          // Stop confetti after a few seconds
          const timer = setTimeout(() => {
            setShowConfetti(false);
          }, 10000);


          return () => clearTimeout(timer);

        }

        dispatch(reset_tenent_select_draw_winner());
      }
    }
  }, [tenent_select_draw_winner_listener]);

  const startNextPrize = () => {
    setIsPrizeComplete(false);
    setCurrentDrawWinner(null);
    const nextPrizeIndex = currentPrizeIndex;

    if (nextPrizeIndex < form_data?.prizes?.length)
    {
      // Set current prize index
      setCurrentPrizeIndex(nextPrizeIndex);


      selectWinnerForPrize();
    }
  };

  const handle_start_live_draw = () => {
    // 
    setParticipantsLoading(true);
    setParticipantsError("");
    // Retrieve Participants
    dispatch(tenant_auth_actions_helper(loading_retrieve_draw_participants, success_retrieve_draw_participants, fail_retrieve_draw_participants, RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_ERROR_MSG, RETRIEVE_PROMOTION_DRAW_PARTICIPANTS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_BEGIN_PROMOTION_DRAW_API}`, { draw_id: form_data?.draw_id, prizes: form_data?.prizes }));
  };

  // Listener
  const retrieve_draw_participants_listener = useSelector((state) => state.retrieve_draw_participants.retrieve_draw_participants);

  useEffect(() => {
    if (retrieve_draw_participants_listener.status !== app_consts.IDLE)
    {
      if (retrieve_draw_participants_listener.status === app_consts.LOADING)
      {
        setParticipantsLoading(true);
        setParticipantsError("");
      } else
      {
        if (retrieve_draw_participants_listener.status === app_consts.FAIL)
        {
          setParticipantsLoading(false);
          setParticipantsError(retrieve_draw_participants_listener.message);
          messageToast(retrieve_draw_participants_listener.message, app_consts.FAIL);
        } else if (retrieve_draw_participants_listener.status === app_consts.SUCCESS)
        {

          const responseData = retrieve_draw_participants_listener.data;

          if (retrieve_draw_participants_listener.data?.draw_prizes?.length > 0)
          {
            setDrawRankPrize(retrieve_draw_participants_listener.data?.draw_prizes[0]);
          }

          stopShuffling();

          const participants = responseData?.participants;

          setDrawWinners(retrieve_draw_participants_listener.data?.winners);

          const remapped_entry_codes = participants?.map(
            (dat) => dat?.promotion_participant?.entry_code
          );

          setCodes(remapped_entry_codes);

          // ✅ Normalize participants
          const normalized = normalizeParticipants(responseData.participants);

          setParticipants(normalized);

          // ✅ Map prizes from API (IMPORTANT)
          const mapped_prizes = responseData?.draw_prizes.map((prize, index) => ({
            id: prize.id,
            prize: prize.prize,
            rank: prize.rank,
            winnerSelected: false
          }));

          setFormData((prev) => ({
            ...prev,
            draw_id: responseData.draw.id,
            prizes: mapped_prizes
          }));

          setPageData((prev) => ({
            ...prev,
            draw: responseData.draw,
            prizes: mapped_prizes
          }));


          successFunction();
          setParticipantsLoading(false);
        }
        dispatch(reset_retrieve_draw_participants());
      }
    }
  }, [retrieve_draw_participants_listener]);

  const handleTryAgain = () => {
    if (page_data?.draw?.status === "pending")
    {
      handle_start_live_draw();
    }
  };

  const displayCodes =
    (currentShufflingCodes && currentShufflingCodes.length > 0)
      ? currentShufflingCodes
      : (codes && codes.length > 0)
        ? codes
        : currentShufflingCodes;

  const isShuffling = draw_winner_loading;
  const isWinner = !!current_draw_winner;

  const winnerMatch = (code) =>
    current_draw_winner?.promotion_participant?.entry_code === code;

  useEffect(() => {
    if (codes && codes.length > 0)
    {
      setFinalCodes(codes);
    }
  }, [codes]);

  const renderSetupState = () => (
    <>
      <BlockHead>
        <BlockTitle tag="h5">Setup Promotion Draw</BlockTitle>
      </BlockHead>
      <div className="mb-2 p-2 bg-light rounded">
        <div className="fw-bold mb-1">
          Number of Prizes: {page_data?.draw?.rules?.max_winners || "--"}
        </div>
        <div className="text-muted small">
          Available Participants: {page_data?.participants?.length || "--"}
        </div>
      </div>
      {
        page_data?.prizes && page_data?.prizes?.length > 0 ? (
          <>
            <div className="nk-tb-list is-separate is-medium mb-3">
              <DataTableHead className="nk-tb-item">
                <DataTableRow size="lg"><span className="sub-text">Prize #</span></DataTableRow>
                <DataTableRow size="lg"><span className="sub-text">Prize Description</span></DataTableRow>
              </DataTableHead>
              {page_data?.prizes?.length > 0 &&
                page_data.prizes.map((item, index) => (
                  <DataTableItem key={item.id}>
                    <DataTableRow>
                      <Row className="g-4">
                        <TextInput
                          required
                          type="text"
                          disabled
                          value={`PRIZE ${index + 1}`}
                          colSize="10"
                        />
                      </Row>
                    </DataTableRow>

                    <DataTableRow>
                      <Row className="g-4">
                        <TextInput
                          required
                          type="text"
                          value={form_data?.prizes?.[index]?.prize || ""}
                          colSize="10"
                          placeholder={`Enter description for Prize ${index + 1}`}
                          handleChange={(e) => {
                            const updated = [...form_data.prizes];
                            updated[index] = {
                              ...updated[index],
                              prize: e.target.value,
                            };
                            setFormData({ ...form_data, prizes: updated });
                          }}
                        />
                      </Row>
                    </DataTableRow>
                  </DataTableItem>
                ))}
            </div>
            {participants_error && (
              <div className="mb-3 w-100">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {participants_error}{" "}
                </Alert>
              </div>
            )}
            <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
              <Button
                onClick={handle_start_live_draw}
                disabled={participants_loading || !(form_data?.draw_id && prize_check())}
                color="primary"
                className="px-5"
              >
                {participants_loading ? (
                  <>
                    <Spinner size="sm" color="light" /> Initializing...
                  </>
                ) : (
                  "Start Live Draw"
                )}
              </Button>
            </Col>
          </>
        ) : (
          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Prizes Data Not Found."} />
        )
      }
    </>
  );

  const renderInDrawState = () => (
    <div className="draw-simulation-container">

      {/* Current Prize Header */}
      <div className="prize-header mb-4">
        <div className="d-flex justify-content-between align-items-center bg-primary bg-opacity-85 text-white p-3 rounded">
          <div>
            <h4 className="mb-0">🎁 {draw_rank_prize?.rank ? `Prize ${draw_rank_prize?.rank}` : ""}</h4>
            <small>
              {draw_rank_prize?.prize?.replace(/_/g, ' ').toUpperCase() || "--"}
            </small>
          </div>
          <div className="text-right">
            <div className="h2 mb-0">{draw_rank_prize?.rank}</div>
            <small>of {page_data?.draw?.rules?.max_winners}</small>
          </div>
        </div>
      </div>

      {/* Prize Progress */}
      <div className="prize-progress mb-4">
        <div className="d-flex justify-content-between mb-2">
          <small>Overall Progress</small>
          <small>{draw_winners?.length} of {page_data?.rules?.max_winners?.length} prizes awarded</small>
        </div>
        <div className="progress mb-3" style={{ height: "10px" }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            style={{ width: `${(draw_winners?.length / form_data?.prizes?.length) * 100}%` }}
          />
        </div>
      </div>

      {/* Shuffling Display */}
      <div className="shuffling-display mb-4">
        <div className="text-center mb-3">
          <h5 className="mb-2">
            {draw_winner_loading
              ? "🎰 Shuffling Entries..."
              : current_draw_winner
                ? "🎉 Winner Selected!"
                : ""}
          </h5>
        </div>

        {/* Code Grid Display */}
        <div className="code-grid mb-4">
          <div className="row">
            <AnimatePresence>
              {displayCodes?.map((entry, index) => (
                <div key={index} className="col-3 mb-2">
                  <motion.div
                    layout
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{
                      scale: 1,
                      opacity: 1,
                      transition: { delay: index * 0.05 }
                    }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    className={`code-box text-center p-2 rounded position-relative overflow-hidden ${isWinner && winnerMatch(entry)
                      ? 'bg-success-soft text-success'
                      : isShuffling && shufflingIndex === index
                        ? 'bg-primary-soft text-primary'
                        : 'bg-light border'
                      }`}
                    style={{
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      boxShadow:
                        isShuffling && shufflingIndex === index
                          ? '0 0 20px rgba(0, 123, 255, 0.5)'
                          : isWinner && winnerMatch(entry)
                            ? '0 0 20px rgba(40, 167, 69, 0.5)'
                            : 'none'
                    }}
                  >
                    {/* Shimmer effect for active shuffling */}
                    {isShuffling && shufflingIndex === index && !isPrizeComplete && (
                      <motion.div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                          pointerEvents: 'none'
                        }}
                        animate={{
                          x: ['-100%', '100%']
                        }}
                        transition={{
                          duration: 0.8,
                          repeat: Infinity,
                          ease: "linear"
                        }}
                      />
                    )}

                    {/* Winner celebration effect */}
                    {isWinner && winnerMatch(entry) && (
                      <motion.div
                        className={`small position-relative ${isShuffling && shufflingIndex === index && !isPrizeComplete
                          ? 'fw-bold text-primary' // Shuffling: bold blue
                          : isWinner && winnerMatch(entry)
                            ? 'fw-bold text-white' // Winner: bold white
                            : 'text-muted' // Default: muted
                          }`}
                        animate={{
                          scale: [1, 1.2, 1],
                          opacity: [0.5, 1, 0.5]
                        }}
                        transition={{
                          duration: 1,
                          repeat: Infinity,
                          ease: "easeInOut"
                        }}
                      />
                    )}

                    <div
                      className={`small position-relative ${isShuffling && shufflingIndex === index && !isPrizeComplete
                        ? 'fw-bold text-primary' // Bold with primary color
                        : isWinner && winnerMatch(entry)
                          ? 'text-white-50'
                          : 'text-muted'
                        }`}
                      style={{ zIndex: 1 }}
                    >
                      {entry}
                    </div>

                    {/* Pulse animation for shuffling */}
                    {isShuffling && shufflingIndex === index && !isPrizeComplete && (
                      <motion.div
                        className="position-absolute top-0 start-0 w-100 h-100 rounded"
                        style={{
                          border: '2px solid rgba(0, 123, 255, 0.6)',
                          pointerEvents: 'none'
                        }}
                        animate={{
                          scale: [1, 1.05, 1],
                          opacity: [0.6, 0.2, 0.6]
                        }}
                        transition={{
                          duration: 0.5,
                          repeat: Infinity,
                          ease: "easeInOut"
                        }}
                      />
                    )}
                  </motion.div>
                </div>
              ))}
            </AnimatePresence>
          </div>
        </div>
      </div>
      {/* Winner Display */}
      {current_draw_winner && (
        <div className="winner-display mb-4">
          <div className="text-center">

            <div
              className="p-4 rounded border bg-white position-relative overflow-hidden"
              style={{
                maxWidth: "420px",
                margin: "0 auto",
                boxShadow: "0 6px 20px rgba(0,0,0,0.05)"
              }}
            >

              {/* 🎉 Confetti burst from center */}
              {showConfetti && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    pointerEvents: "none"
                  }}
                >
                  <Confetti
                    width={420}
                    height={260}
                    numberOfPieces={140}
                    recycle={false}
                    gravity={0.3}
                    initialVelocityY={8}
                    initialVelocityX={6}
                    confettiSource={{
                      x: 210,     // center horizontally (half of 420)
                      y: 150,     // adjust to where code box sits
                      w: 0,
                      h: 0
                    }}
                  />
                </div>
              )}

              <div className="mb-3">
                <Icon name="award" size="2x" className="text-success" />
              </div>

              <h5 className="mb-3 text-success font-weight-bold">
                🎉 Winner Selected
              </h5>

              <div className="mb-2 font-weight-bold" style={{ fontSize: "1.1rem" }}>
                {[
                  current_draw_winner?.participant?.first_name,
                  current_draw_winner?.participant?.middle_name,
                  current_draw_winner?.participant?.last_name
                ].filter(Boolean).join(" ")}
              </div>

              {/* 🎯 TARGET AREA */}
              <div
                className="mb-3 px-3 py-2 rounded text-monospace position-relative"
                style={{
                  background: "#f8f9fa",
                  border: "1px dashed #dee2e6",
                  fontSize: "1.2rem",
                  letterSpacing: "1px"
                }}
              >
                {current_draw_winner?.promotion_participant?.entry_code}
              </div>

              <div className="small text-muted mb-2">
                {current_draw_winner?.participant?.mobile_number}
              </div>

              <div className="mt-2">
                <span className="badge badge-outline-success">
                  {current_draw_winner?.promotion_draw_winner?.prize}
                </span>

                {current_draw_winner?.isFallback && (
                  <Badge color="warning" className="ml-2">
                    Fallback
                  </Badge>
                )}
              </div>

            </div>

          </div>
        </div>
      )}

      {/* Loading State */}
      <AnimatePresence>
        {draw_winner_loading && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="mb-3"
          >
            <Alert color="info" className="d-flex align-items-center gap-2">
              <Spinner size="sm" />
              <span>Selecting winner...</span>
            </Alert>
          </motion.div>
        )}
      </AnimatePresence>


      {/* Error State */}
      {draw_winner_error && (
        <Alert color="danger" className="mb-3 text-center">
          <div className="mb-2">{draw_winner_error}</div>

          <div className="d-flex justify-content-center mt-3">
            <Button
              color="primary"
              onClick={selectWinnerForPrize}
              disabled={draw_winner_loading}
            >
              {draw_winner_loading ? (
                <>
                  <Spinner size="sm" color="light" /> Retrying...
                </>
              ) : (
                "Try Again"
              )}
            </Button>
          </div>
        </Alert>
      )}

      {/* Next Prize Button */}
      {draw_winners?.length !== form_data?.prizes?.length && (
        <div className="text-center mt-4">
          {
            !draw_winner_error && (
              <>
                <Button
                  onClick={startNextPrize}
                  color="primary"
                  className="px-5"
                >
                  <Icon name="arrow-right" /> {draw_winners?.length === 0 ? "Select First Winner" : "Select Next Winner"}
                </Button>
              </>
            )
          }
        </div>
      )}

      {/* Draw Complete Message */}
      {draw_winners?.length === form_data?.prizes?.length && (
        <Alert color="success" className="mt-3">
          <Icon name="check-circle" className="mr-2" />
          All prizes have been awarded! Showing results...
        </Alert>
      )}

      {/* Selected Winners So Far */}
      {draw_winners?.length > 0 && (
        <div className="selected-winners-section mt-4">

          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">🎉 Winners Selected</h6>
            <span className="text-muted small">
              {draw_winners.length} selected
            </span>
          </div>

          <div className="row">
            {draw_winners?.map((winner, index) => {
              const name = [
                winner?.participant?.first_name,
                winner?.participant?.middle_name,
                winner?.participant?.last_name
              ].filter(Boolean).join(" ");

              return (
                <div key={index} className="col-md-6 mb-3">
                  <div
                    className="p-3 rounded border bg-white h-100"
                    style={{
                      transition: "all 0.2s ease",
                    }}
                  >

                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <div className="d-flex align-items-center">

                        <div
                          className="mr-3 d-flex align-items-center justify-content-center"
                          style={{
                            width: 38,
                            height: 38,
                            borderRadius: "50%",
                            background: "#28a745",
                            color: "#fff",
                            fontWeight: 600
                          }}
                        >
                          {winner?.promotion_draw_winner?.rank}
                        </div>

                        <div>
                          <div className="font-weight-bold">
                            {name || "Unnamed"}
                          </div>
                          <div className="small text-muted">
                            {winner?.promotion_draw_winner?.prize}
                          </div>
                        </div>

                      </div>
                    </div>

                    <div
                      className="px-2 py-1 mt-2 rounded text-monospace small"
                      style={{
                        background: "#f8f9fa",
                        border: "1px dashed #dee2e6"
                      }}
                    >
                      {winner?.promotion_participant?.entry_code}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>

        </div>
      )}
    </div>
  );

  const renderResultsState = () => (
    <div className="results-container position-relative">

      {/* 🎉 FULLSCREEN CONFETTI */}
      {showConfetti && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            pointerEvents: "none",
            zIndex: 9999
          }}
        >
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            numberOfPieces={400}
            recycle={false}
            gravity={0.25}
            initialVelocityY={12}
            initialVelocityX={10}
          />
        </div>
      )}

      <BlockHead>
        <BlockTitle tag="h5">🏆 Draw Complete - Results 🏆</BlockTitle>
      </BlockHead>

      <div className="text-center mb-4">
        <div className="winner-summary bg-light p-4 rounded mb-4">
          <Icon name="trophy" size="2x" className="text-warning mb-3" />
          <h3 className="text-success">Congratulations to All Winners!</h3>
          <p className="text-muted">
            {draw_winners?.length} winners selected from {page_data?.participants?.length} participants
          </p>
        </div>

        {/* Final Winners Table */}
        <div className="nk-tb-list is-separate is-medium mb-3">
          <DataTableHead className="nk-tb-item">
            <DataTableRow size="sm"><span className="sub-text">#</span></DataTableRow>
            <DataTableRow size="lg"><span className="sub-text">Winner</span></DataTableRow>
            <DataTableRow size="sm"><span className="sub-text">Code</span></DataTableRow>
            <DataTableRow size="lg"><span className="sub-text">Prize</span></DataTableRow>
            <DataTableRow size="md"><span className="sub-text">Status</span></DataTableRow>
          </DataTableHead>

          {draw_winners?.map((item, index) => {
            const name = [
              item?.participant?.first_name,
              item?.participant?.middle_name,
              item?.participant?.last_name
            ].filter(Boolean).join(" ");

            return (
              <DataTableItem key={index}>
                <DataTableRow>
                  <span>{item?.promotion_draw_winner?.rank}</span>
                </DataTableRow>

                <DataTableRow>
                  <div className="user-name font-weight-bold">{name}</div>
                  <div className="small text-muted">
                    {item?.participant?.email_address}
                  </div>
                </DataTableRow>

                <DataTableRow>
                  <code>{item?.promotion_participant?.entry_code}</code>
                </DataTableRow>

                <DataTableRow>
                  <div className="text-primary">
                    {item?.promotion_draw_winner?.prize}
                  </div>
                </DataTableRow>

                <DataTableRow>
                  <Badge color="success">Awarded</Badge>
                </DataTableRow>
              </DataTableItem>
            );
          })}
        </div>

        <div className="summary-stats row mb-4">
          <div className="col-md-4 mb-3">
            <div className="stat-card bg-primary text-white p-3 rounded text-center">
              <div className="h4 mb-1">{draw_winners?.length || 0}</div>
              <div className="small">Winners Selected</div>
            </div>
          </div>

          <div className="col-md-4 mb-3">
            <div className="stat-card bg-warning text-white p-3 rounded text-center">
              <div className="h4 mb-1">{draw_winners?.length}</div>
              <div className="small">Prizes Awarded</div>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <Button
            color="success"
            onClick={() => {
              successFunction();
              close_modal();
            }}
            className="px-5"
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Modal isOpen={isOpen} toggle={!(draw_state_loading || draw_winner_loading) ? () => {
        successFunction();
        close_modal();
      } : undefined} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={!(draw_state_loading || draw_winner_loading) ? () => {
          successFunction();
          close_modal();
        } : undefined}>
          {current_state === "in_draw" ? " Live Draw in Progress" :
            current_state === "results" ? " Draw Results" :
              "Initiate Promotion Draw"}
        </ModalHeader>
        <ModalBody>
          <Block>
            {
              participants_loading ? (
                <AuthTenantLoader
                  tenant_info={tenant_info}
                  loading_message="Retrieving Participants..."
                />
              ) : participants_error ? (
                <>
                  <AuthTenantNoData
                    tenant_info={tenant_info}
                    no_data_message={participants_error}
                  />
                  <div className="d-flex justify-content-center mt-3">
                    <Button
                      color="primary"
                      onClick={handleTryAgain}
                      disabled={participants_loading}
                    >
                      {participants_loading ? (
                        <>
                          <Spinner size="sm" color="light" /> Retrying...
                        </>
                      ) : (
                        "Try Again"
                      )}
                    </Button>
                  </div>
                </>
              ) : drawComplete ? (
                // ✅ SHOW RESULTS WHEN DONE
                renderResultsState()
              ) : page_data?.draw?.status === "pending" ? (
                renderSetupState()
              ) : page_data?.draw?.status === "in_draw" ? (
                draw_state_loading ? (
                  <AuthTenantLoader
                    tenant_info={tenant_info}
                    loading_message="Retrieving Data..."
                  />
                ) : draw_state_error ? (
                  <AuthTenantPageError
                    tenant_info={tenant_info}
                    error_message={draw_state_error}
                  />
                ) : (
                  renderInDrawState()
                )
              ) : null
            }
          </Block>
        </ModalBody>
      </Modal>
    </>
  );
};

export default InitiatePromotionDrawModal;